import * as PIXI from 'pixi.js'

class Bubble {
  constructor (game) {
    this.game = game
    this.any = false
    this.offsetX = -20
    this.offsetY = -150

    this.textureArray = []
    for (var i = 0; i < 9; i++) {
      const texture = PIXI.Texture.from(`bubble${i + 1}`)
      this.textureArray.push(texture)
    }
    this.view = new PIXI.extras.AnimatedSprite(this.textureArray)
    this.view.scale.set(0.25)
    this.view.animationSpeed = 0.4
    this.view.loop = false
  }

  setPosition (x, y) {
    this.view.x = x
    this.view.y = y
  }

  update (originX, originY) {
    const x = originX + this.offsetX
    const y = originY + this.offsetY
    this.setPosition(x, y)
  }

  zoomOut () {
    if (this.any) {
      this.view.stop()
      this.reset()
    }

    this.view.textures = this.textureArray
    this.any = true
    this.game.app.stage.addChild(this.view)
    this.view.play()
  }

  zoomIn () {
    this.view.textures = this.textureArray.slice().reverse()
    this.view.onComplete = () => {
      this.reset()
    }
    this.view.play()
  }

  reset () {
    this.any = false
    this.game.app.stage.removeChild(this.view)
    this.view.onComplete = null
  }
}

export default Bubble
